/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';

import SetPasswordTemplate from 'components/pages/token/SetPassword/SetPassword.template';
import MfaCodeEntry from 'components/pages/mfaCode';

import userSelectors from 'redux/reduxStore/user';

import navigationActions from 'redux/actions/navigation';

import routeNames from 'lib/routeNames';


function mapStateToProps(state) {
  const user = userSelectors.getLoggedInUser(state);
  return {
    userId: user.id,
    isMfaRequired: user.mfa_enabled,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goBack());
    },
    goHome: () => {
      dispatch(navigationActions.goTo(routeNames.home()));
    },
  }
}

class ConfirmChangeEmailPresenter extends React.Component {

  constructor(props) {
    super(props);

    this.confirmEmailChange = this.confirmEmailChange.bind(this);
    this.confirmEmailChangeMfa = this.confirmEmailChangeMfa.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);

    this.state = {
      password: '',
      passwordSubmitted: false,
    };
  }

  confirmEmailChange() {
    if (this.props.isMfaRequired) {
      this.setState({
        passwordSubmitted: true,
      })
      return;
    }

    return this.props.confirmEmailChange(this.props.userId, this.props.token, this.state.password);
  }

  confirmEmailChangeMfa(mfaCode) {
    return this.props.confirmEmailChangeMfa(this.props.userId, this.props.token, this.state.password, mfaCode);
  }

  handleOnFocus() {

  }

  render() {
    if (this.state.passwordSubmitted) {
      return (
        <MfaCodeEntry
          token={this.props.token}
          submitMfaCode={this.confirmEmailChangeMfa}
          goBack={this.props.logout}
        />
      );
    } else {
      return (
        <SetPasswordTemplate
          titlePhrase={{ id: 'loginPwd.changeEmailTitle.text' }}
          goBack={this.props.goHome}
          password={this.state.password}
          isPasswordInvalid={this.state.password.length < 1}
          isPasswordStrengthVisible={false}
          submitPasswordChange={this.confirmEmailChange}
          onChangePassword={(password) => {
            this.setState({
              password,
            });
          }}
          onFocus={this.handleOnFocus}
        />
      );
    }
  }
}
ConfirmChangeEmailPresenter.propTypes = {
  token: PropTypes.string.isRequired,
  isMfaEnabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmChangeEmailPresenter);
